import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["submit", "message"]

  submit() {
    this.submitTarget.disabled = true
    this.submitTarget.value = "Extracting..."
    this.submitTarget.classList.add("opacity-70", "cursor-not-allowed")
    this.messageTarget.classList.remove("hidden")
  }
}